import axios from '@/config/axios';

//获取用户信息(可以用来判断是否登录)
export const getUserInfoService = () => axios("/centre/mine/info.jsp?ab=wx_img,text&rb=*");

//获取微信登录参数
export const getWXLoginParams = () => {
    return axios(
        `/common/conf/oauth2.json`
    )
};

//获取登录短信验证码
export const getMesCode = (options = {}) => {
    let def = { phone: '', captcode: '' };
    let result = { ...def, ...options };
    return axios(
        `/centre/oauth2/sms/create.act?phone=${result.phone}&captcode=${result.captcode}`,
    )
};

//登录\注册账号
export const userLogin = (formdata) => {
    return axios(
        `/centre/oauth2/sess/create.act`,
        formdata
    )
};

//退出登录
export const userSign = () => {
    return axios(
        `/centre/sign/delete.act`
    )
};


//绑定手机号发送短信验证码
export const sendSmsCode = (phone, captcode) => {
    return axios(
        `/centre/mine/sms-set-phone.jsp?act=send&phone=${phone}&captcode=${captcode}`
    )
};

//绑定手机号
export const sendBindphone = (phone, code) => {
    return axios(
        `/centre/mine/sms-set-phone.jsp?act=save&phone=${phone}&capt_sms=${code}`
    )
};


// WEBPACK FOOTER //
// ./src/service/login.js